export default __webpack_public_path__ + "static/media/information-alert-icon.1d09864d.svg";